import Vue from 'vue'
import Vuex from 'vuex'

import * as tokenUtil from "../cache/token"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: tokenUtil.get(),
        userInfo: {}
    },
    getters: {
        getToken(state) {
            return state.token;
        },
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
        },
    },
    actions: {
        // 设置 token 的 action，可以包含异步操作或额外的逻辑
        async setTokenAction({ commit }, token) {
            commit('setToken', token);
            // 这里可以添加其他逻辑，比如将 token 保存到 localStorage 或 cookie 中
            tokenUtil.set(token)
        },


    },
    modules: {

    }
})
